import { render, staticRenderFns } from "./TrainLayout.vue?vue&type=template&id=239771fc&scoped=true"
import script from "./TrainLayout.vue?vue&type=script&lang=js"
export * from "./TrainLayout.vue?vue&type=script&lang=js"
import style0 from "./TrainLayout.vue?vue&type=style&index=0&id=239771fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239771fc",
  null
  
)

export default component.exports